<template>
  <div id="app">
    <base-loader />
    <notification />
    <SessionTimeoutDialog 
      ref="sessionTimeoutDialog" 
      @session-resumed="handleSessionResumed" 
    />
    <router-view />
  </div>
</template>

<script>
import { Notification, BaseLoader } from '@/components/base';
import SessionTimeoutDialog from '@/components/SessionTimeoutDialog.vue';

// CONFIGURATION (In Milliseconds)
const WARNING_DELAY = 150000; // 2 minutes 30 seconds
const COUNTDOWN_DURATION = 30000; // 30 seconds
const MAX_IDLE_TIME = WARNING_DELAY + COUNTDOWN_DURATION; // 3 minutes total

export default {
  components: {
    Notification,
    BaseLoader,
    SessionTimeoutDialog,
  },
  data() {
    return {
      sessionCheckInterval: null,
    };
  },
  mounted() {
    if (this.$store.getters['auth/isLoggedIn']) {
      this.startSessionCheck();
    }
    window.addEventListener('mousemove', this.handleUserActivity);
    window.addEventListener('keydown', this.handleUserActivity);
  },
  beforeDestroy() {
    this.stopSessionCheck();
    window.removeEventListener('mousemove', this.handleUserActivity);
    window.removeEventListener('keydown', this.handleUserActivity);
  },
  methods: {
    startSessionCheck() {
      // Clear any existing interval to prevent duplicates
      if (this.sessionCheckInterval) clearInterval(this.sessionCheckInterval);

      this.sessionCheckInterval = setInterval(() => {
        const lastActivity = this.$store.state.auth.lastActivity;
        if (!lastActivity) return;

        const inactiveTime = Date.now() - lastActivity;

        if (inactiveTime >= MAX_IDLE_TIME) {
          this.stopSessionCheck();
          this.$store.dispatch('auth/logout');
          return;
        }

        if (inactiveTime >= WARNING_DELAY && this.$refs.sessionTimeoutDialog.countdown === 30) {
          this.$refs.sessionTimeoutDialog.startDialog();
        }
      }, 10000);
    },
    stopSessionCheck() {
      if (this.sessionCheckInterval) {
        clearInterval(this.sessionCheckInterval);
        this.sessionCheckInterval = null;
      }
    },
    handleUserActivity() {
      if (this.$store.getters['auth/isLoggedIn']) {
        this.$store.dispatch('auth/updateLastActivity');
      }
    },
    handleSessionResumed() {
      this.handleUserActivity();
      this.startSessionCheck(); 
    },
  },
  watch: {
    '$store.getters["auth/isLoggedIn"]'(newValue) {
      if (newValue) {
        this.startSessionCheck();
      } else {
        this.stopSessionCheck();
      }
    },
  },
};
</script>

<style lang="scss">
@import './index.scss';
</style>